<!--充电机数据 -->
<template>
  <div id="dataIndex">
    <!-- <el-input v-model="searchObj.sn" :placeholder="$t('BondOrUpdateDevice.SN')" class="input-with-select" clearable style="width: auto;">
    </el-input>
    <el-button type="primary" @click="toDetails" >查询</el-button> -->

    <!-- 列表 -->
    <div style="position: relative;">
      <!-- 删选 -->
      <div class="searchWarp">
        <el-input v-model="searchObj.sn" :placeholder="$t('BondOrUpdateDevice.SN')" class="input-with-select" clearable @clear="changeSearch">
          <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
        </el-input>
        <el-input v-model="searchObj.proModule" :placeholder="$t('BondOrUpdateDevice.Model')" class="input-with-select" clearable @clear="changeSearch">
          <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
        </el-input>
      </div>
      <el-table id="dataIndexTable" v-loading="loading" :data="tableData" style="width: 100%" border>
        <el-table-column prop="sn" :label="$t('BondOrUpdateDevice.SN')" align="center" />
        <el-table-column prop="proModule" :label="$t('BondOrUpdateDevice.Model')" align="center" />
        <el-table-column prop="makeDateZh" :label="$t('QR.Dateofmanufacture')" align="center" />
        <el-table-column prop="" :label="$t('yhubReport.Operating')" align="center">
          <template slot-scope="scope">
            <div style="text-align: center;">
              <el-button type="primary" icon="el-icon-view" size="mini" @click="gotoDetailPage(scope.row)" />
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 列表模块————分页 -->
      <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
        <div class="pagination-container">
          <el-pagination
            v-if="pageshow"
            background
            current-page.sync="listQuery.pageInfo.page"
            :page-sizes="listQuery.pageInfo.pageList"
            :page-size="listQuery.pageInfo.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="listQuery.pageInfo.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { findBluetoothDeviceList2 } from '@/api/blueTooth'
import { pagination } from '@/utils/init_table'
import { getDateAndHour } from '@/utils/updateTime.js'

export default {
  data() {
    return {
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end,
      loading: true,
      searchObj: {
        sn: '',
        proModule: ''
      },
      tableData: []
    }
  },
  created() {
    this.queryList()
  },
  methods: {
    toDetails () {
      if (!this.searchObj.sn) return
      this.$router.push({
        path: '/blueTooth/chargeDataDetail',
        query: {
          chargerSn: this.searchObj.sn,
        }
      })
    },
    queryList() {
      var param = {
        'sn': this.searchObj.sn,
        'proCode': this.searchObj.proModule,
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      this.loading = true
      findBluetoothDeviceList2(param).then(res => { // 基本信息
        this.loading = false
        if (res.resultCode === 1001 && res.resultModel) {
        // console.log(res.resultModel)
          this.tableData = res.resultModel.list
          this.listQuery.pageInfo.total = res.resultModel.total // 分页
          this.tableData.forEach(v => {
            if (v.makeDate)v.makeDateZh = getDateAndHour(v.makeDate, 'noTime')
          })
        }
      })
    },
    gotoDetailPage(row) { // 去详情页
      var routeData = this.$router.resolve({
        path: '/blueTooth/chargeDataDetail',
        query: {
          chargerSn: row.sn,
          proModule: row.proModule,
          makeDateZh: row.makeDateZh
        }
      })
      window.open(routeData.href, '_self')
    },
    // 筛选改变事件
    changeSearch() {
      if (this.searchObj.sn) {
        // 去掉首尾空格
        this.searchObj.sn = this.searchObj.sn.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      }
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    // 分页----start
    handleSizeChange(val, e) {
      // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange(val, e) {
      // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    }
    // 分页----end

  }
}
</script>
<style lang="scss">
#dataIndex{
  background: #fff;
  padding: 13px 20px;
  .searchWarp{
    margin-bottom: 10px;
  }
  .searchWarp .el-input-group {
    width: 40%!important;
    max-width: 400px!important;
    margin-top: 13px;
  }
  #dataIndexTable .el-button{
    margin:5px 0 ;
  }
}
</style>
